package Structs

import DataBase.SHOP_URL
import DataBase.UINKDBInterface
import Utils.cofcAdminFlagEnabled
import kotlinx.serialization.Serializable
import myName
import kotlin.js.JsExport


@myName("CofcConf")
@Serializable
data class CofcConf(
    val state: Int,
    val date_control: Int,
    val with_price: Int,
    val conversion_rate_blocker: Int, // 0 = on first not blocking, 1 second blocking, 2 second no blocking, 3 first blocking, 20 = variable per-line conversion (אורך × wrapped)
    val filterOnlyUse: Int,
    /** -1 hide chips and in-list category headers; 0 no grouping; 1–4 group; 10 multi-tag. */
    val sortByCategory: Int,
    val without_images: Int,
    val product_id: Int,
    var time_close: String? = null,
    val daily_link: Int,
    val daily_close: Int,
    val auto_open_without_cart: Int,
    val text: String? = null,
    val stock:Int=0, // 0 none, 1 show, 2 warn, 3 block; 10 = client inventory upload (AI drafts)
    val credit:Int=0,
    val multi_order:Int=0,
    val no_need:Int=0,
    val need_english:Int=0,
    val need_notes:Int=0,
    val base_order:Int=0,
    var time1:String?=null,
    var time2:String?=null,
    var time3:String?=null,
    var time4:String?=null,
    var time5:String?=null,
    var time6:String?=null,
    var time7:String?=null,
    val delivery:Int=0,
    val delivery_free_th: Float= 100000000f,
    val return_state: Int = 0,
    val unlock_p:Int = 0,
    val full_prod: Int = 0,
    val inverse_avail: Int = 0,
    val match_dv: Int = 0,
    /** Bitmask: 1=external driver links, 2=client self-signup, 4=BTC. */
    val rep_link: Int = 0,
    /** JSON array: [{"from":"YYYY-MM-DD","to":"YYYY-MM-DD","label":"פסח","kind":"holiday"}] */
    @Serializable(with = BlockedDatesJsonStringSerializer::class)
    val blocked_dates: String? = null,
    /** 0 = third (order-only) unit feature off, 1 = enabled for this company */
    val third_unit_on: Int = 0,
    /** 0 = agents unconstrained when placing orders; 1 = apply core COFC client constraints
     * (product locks, date/time cutoffs, blocked dates, delivery days, min order) to agent orders too. */
    val agent_constraints: Int = 0,
    /** Explicit weekend switch; older rows derive it from a negative daily_close value. */
    val weekend_block: Int = 0,

    /** 0 = old app at [ORDER_SHOP_HOST]/ ; 1 = new app at [ORDER_SHOP_HOST]/v2.
     * Freely toggled by the company from הגדרות לינק (not admin_flags-gated). */
    val link_version: Int = 0,
    /** 0 = BTC (public/occasional ordering) disabled; >0 = ent_id of the "לקוחות מזדמנים" client
     * that receives all BTC orders (buyer details are carried in client_order_note.static_data) */
    val btc_client_id: Int = 0,
    /** 1 = show "הוזמן X פעמים / הוזמן לאחרונה בתאריך" layer in the client app */
    val statistics: Int = 0,
    /** bitmask for אזור אישי: 1=documents (delivery notes+invoices), 2=order statuses, 4=document PDF download */
    val personal_area: Int = 0,
    /** JSON array: forced checkout fields, e.g. [{"field":"notes2","label":"מספר סניף","required":1}] */
    @Serializable(with = BlockedDatesJsonStringSerializer::class)
    val required_fields: String? = null,
    /** JSON: server-enforced client blocking rules, e.g. {"obligo":1,"debt_gt":5000,"block_msg":"..."} */
    @Serializable(with = BlockedDatesJsonStringSerializer::class)
    val block_rules: String? = null,
    /** JSON: popup shown to the client before ordering, e.g.
     * {"active":1,"title":"שימו לב","text":"...","mode":"once_per_day"} (mode: every_order|once_per_day|once) */
    @Serializable(with = BlockedDatesJsonStringSerializer::class)
    val popup_message: String? = null,
    /** JSON: company-default per-weekday order cutoff (1=Sunday..7=Saturday), e.g. {"1":"14:00","6":"11:00"}.
     * Used when a product has neither its own [OrderProduct.day_hour_locks] entry nor a flat [OrderProduct.hourLock]. */
    @Serializable(with = BlockedDatesJsonStringSerializer::class)
    val day_time_locks: String? = null,
    /** JSON: platform-admin-only feature gates (monetized features), e.g.
     * {"btc":1,"statistics":1,"personal_area":1,"driver_links":1}.
     * A company user may only change a gated cofc field when its gate is 1 here (enforced server-side).
     * Note: link_version is not gated — companies switch to v2 themselves. */
    @Serializable(with = BlockedDatesJsonStringSerializer::class)
    val admin_flags: String? = null,
    /** JSON array: documents the company demands in the new-client signup flow, e.g.
     * [{"key":"tofes_871","label":"טופס 871","required":1}] */
    @Serializable(with = BlockedDatesJsonStringSerializer::class)
    val clientsign_docs: String? = null,
    /** JSON: client-card self-fill terms checkboxes + signature, e.g.
     * {"intro":"אישור הלקוח לפני שליחה","require_sign":1,
     *  "items":[{"key":"pay1","text":"...","required":1}]} */
    @Serializable(with = BlockedDatesJsonStringSerializer::class)
    val clientsign_terms: String? = null,
    /** JSON array: company-level holiday/special ordering windows, e.g.
     * [{"id":"jul-29","order_until":"2026-07-19 14:00","delivery_dates":["2026-07-29"],
     * "product_ids":[123,456],"client_ids":[10],"product_mode":"include","client_mode":"all",
     * "hide_others":1,"label":"חג","active":1}].
     * `product_mode`/`client_mode` are all|card|include|exclude (legacy: empty ids = all, else include).
     * `card` keeps the client/product weekday mask and treats ids as extras. `exclude` denies listed
     * SKUs. A live matching window reopens blocked/non-delivery dates for that client; `include`
     * is exclusive for those products. After [order_until] the products the window allowed are
     * closed for those delivery dates; other SKUs follow the card. Never bypasses forceLock or
     * unavailability. Inactive (`active` 0) windows are ignored. See [Utils.holidayProductVerdict]. */
    @Serializable(with = BlockedDatesJsonStringSerializer::class)
    val product_date_windows: String? = null,
    /** JSON: v2 storefront appearance + personal-area hub, e.g.
     * {"theme":"dark","product_view":"compact","prices_tax":"include",
     *  "saved_businesses":1,"businesses_rev":0}.
     * `product_view` is default|compact|rows.
     * `prices_tax` is client (follow client-card include_tax, default) | include | exclude.
     * `saved_businesses` 1 (default) = "העסקים שלי" hub on the device; 0 = hide and stop remembering.
     * `businesses_rev` is a monotonic flush counter: v2 wipes local saved businesses when it increases.
     * Defaults preserve the current light/list UI and per-client VAT display. */
    @Serializable(with = BlockedDatesJsonStringSerializer::class)
    val display_settings: String? = null,
    /** Existing-order line that is (or becomes) locked mid-edit:
     * 0 (default) = freeze original qty, no remove, no qty/unit change;
     * 1 = allow remove only (qty/unit stay frozen);
     * 2 = allow decrease only (qty may go down incl. to 0; unit frozen; no increase);
     * 3 = allow full edit (qty/unit/remove unrestricted). */
    val allow_locked_existing_removal: Int = 0,
    /** JSON: company-wide recurring per-DELIVERY-weekday cutoff for every client, same shape as
     * [OrderProduct.delivery_cutoff_rules], e.g. {"1":{"weekday":4,"time":"14:00"}}
     * (Sunday delivery closes for ordering on Wednesday at 14:00). When set for a delivery
     * weekday, it REPLACES `daily_close` / `time_close` for that weekday at the date-picker
     * level. A product-level [OrderProduct.delivery_cutoff_rules] entry still overrides this
     * for that product. */
    @Serializable(with = BlockedDatesJsonStringSerializer::class)
    val delivery_cutoff_rules: String? = null,
    /** 0 = quantity (return/amount), 1 = money (return money / amount money). */
    val return_pct_mode: Int = 0,
    /** v2 catalog: products that cannot be ordered for the selected date
     * (cutoff / weekday / forceLock / available=0).
     * 0 = show them marked as not available (default, current storefront);
     * 1 = hide them so the client cannot browse/search them (still kept if already
     * in the cart / existing order). Some companies hide them so clients do not
     * call about items labeled "לא זמין". */
    val hide_unavailable: Int = 0,
) {
    var totalMoney:Float?=null
    init {
        if(time_close == "" || time_close=="None" || time_close=="NULL" || time_close=="00:00"){
            time_close = null
        }
        if(time1 == "" || time1=="None" || time1=="NULL"){
            time1 = null
        }
        if(time2 == "" || time2=="None" || time2=="NULL"){
            time2 = null
        }
        if(time3 == "" || time3=="None" || time3=="NULL"){
            time3 = null
        }
        if(time4 == "" || time4=="None" || time4=="NULL"){
            time4 = null
        }
        if(time5 == "" || time5=="None" || time5=="NULL"){
            time5 = null
        }
        if(time6 == "" || time6=="None" || time6=="NULL"){
            time6 = null
        }
        if(time7 == "" || time7=="None" || time7=="NULL"){
            time7 = null
        }

    }
    fun second(): Boolean {
        return conversion_rate_blocker == 1 || conversion_rate_blocker == 2
    }

    fun first(): Boolean {
        return conversion_rate_blocker == 0 || conversion_rate_blocker == 3
    }

    fun block(): Boolean {
        return conversion_rate_blocker == 1 || conversion_rate_blocker == 3
    }

    fun thirdUnit(): Boolean {
        return third_unit_on == 1
    }

    fun agentConstraintsEnabled(): Boolean {
        return agent_constraints == 1
    }

    /** Platform-admin feature gate from [admin_flags] (admin-panel «שערי פיצ׳רים»). */
    fun adminFlagEnabled(gate: String): Boolean {
        return cofcAdminFlagEnabled(admin_flags, gate)
    }

    /** true when the company bought the marketing photo-collage feature. */
    fun collageEnabled(): Boolean {
        return adminFlagEnabled("collage")
    }

    /** true when this company is switched to the new (v2) ordering app. */
    fun v2Enabled(): Boolean {
        return link_version == 1
    }

    /** true when BTC (occasional/public) ordering is turned on for this company. */
    fun btcEnabled(): Boolean {
        return btc_client_id > 0
    }

    fun statisticsEnabled(): Boolean {
        return statistics == 1
    }

    fun personalAreaDocuments(): Boolean {
        return (personal_area and 1) == 1
    }

    fun personalAreaStatuses(): Boolean {
        return (personal_area and 2) == 2
    }

    fun personalAreaPdf(): Boolean {
        return (personal_area and 4) == 4
    }

    fun url(client: Client, token: String, date: String): String? {
        val tex = if (text.isNullOrEmpty())
            "שלום ${client.getName()} ${client.getOutId()}אנא בצע הזמנה עבור ${UINKDBInterface.activeDB.getUser().first?.user_company_print_name}"
        else {
            var t = text.replace("#name", client.getName())
            t = t.replace("#id", client.id.toString())
            t = t.replace("#external_id", client.getExternalId())
            t = t.replace("#date", date)
            t = t.replace("\\n", "%0a")
            t
        }

        return "`${tex} %0a %0a ${orderShopLink(token, date, returns = false, v2 = v2Enabled())} %0a"
    }

    companion object {
        const val ORDER_SHOP_HOST = SHOP_URL

        fun orderShopBase(v2: Boolean): String =
            if (v2) "$ORDER_SHOP_HOST/v2/" else "$ORDER_SHOP_HOST/"

        /**
         * Self-order URL for WhatsApp / SMS / copy-link flows.
         * v2: `https://nihulkav.shop/v2/?pass=…&date=…&returns=…`
         * legacy: `https://nihulkav.shop/?pass=…&date=…&returns=…`
         */
        fun orderShopLink(
            pass: String,
            date: String,
            returns: Boolean = false,
            v2: Boolean = false,
            paramName: String = "pass",
        ): String {
            val returnsFlag = if (returns) "true" else "false"
            return "${orderShopBase(v2)}?$paramName=$pass&date=$date&returns=$returnsFlag"
        }
    }
}

